import React, { useEffect, useState } from 'react'
import '../../Assests/css/studentApplication.css'
import MultiSelectFilter from '../../components/MultiSelectFilter';
import StudentApplicationCard from '../../components/StudentApplicationCard';
import { applicationService } from '../../services/applicationService';
import Filters from '../../components/MultiSelectFilter';

export default function StudentApplication({ userRole,permission }) {
    const [recentApplicationData, setRecentApplicationData] = useState([])
    const [allApplicationData, setAllApplicationData] = useState([])
    const [allGradeList, setAllGradeLIst] = useState([])
    const [allApplicationListFilter, setAllApplicationListFilter] = useState([])
    const [allStatusList, setAllStatusList] = useState([])
    const [loader, setLoader] = useState(false)

    const [selectedFilters, setSelectedFilters] = useState({
        apps: [],
        grades: [],
        status: [],
    });
    const [selectedFiltersIds, setSelectedFiltersIds] = useState({
        apps: "",
        grades: "",
        status: "",
    });


    const filterConfigs = [
        { key: "apps", label: "All Applications", options: allApplicationListFilter, color: "blue" },
        { key: "grades", label: "All Grades", options: allGradeList, color: "green" },
        { key: "status", label: "All Status", options: allStatusList, color: "orange" },
    ];

    useEffect(() => {
        getAllGradeData()
        getAllApplicationForFilter()
        getAllApplicationStatusForFilter()
    }, [])

    useEffect(() => {
        getStudentApplicationList()
    }, [selectedFiltersIds?.apps, selectedFiltersIds?.grades, selectedFiltersIds?.status])

    async function getAllGradeData() {
        try {
            const response = await applicationService.getAllGrades()
            if (response?.success == true) {
                setAllGradeLIst(response?.data)
            } else {
                setAllGradeLIst([])
            }
        } catch (e) {
            console.error('Error fetching data:', e)
        }
    }

    async function getAllApplicationForFilter() {
        try {
            const response = await applicationService.getAllApplicationForFilter()
            if (response?.success == true) {
                setAllApplicationListFilter(response?.data)
            } else {
                setAllApplicationListFilter([])
            }
        } catch (e) {
            console.error('Error fetching data:', e)
        }
    }

    async function getAllApplicationStatusForFilter() {
        try {
            const response = await applicationService.getAllApplicationStatusForFilter()
            if (response?.success == true) {
                setAllStatusList(response?.data)
            } else {
                setAllStatusList([])
            }
        } catch (e) {
            console.error('Error fetching data:', e)
        }
    }

    async function getStudentApplicationList() {
        try {
            setLoader(true)
            let data = JSON.stringify({
                'page': '1',
                'limit': '10',
                'application_id': selectedFiltersIds?.apps ? selectedFiltersIds?.apps : null,
                'grade_id': selectedFiltersIds?.grades ? selectedFiltersIds?.grades : null,
                'status': selectedFiltersIds?.status ? selectedFiltersIds?.status : null,
            })
            let response = null
            if (userRole?.role_name == 'Student') {
                response = await applicationService.getStudentAllApplications(data)
            } else {
                response = await applicationService.getFamilyAllApplications(data)
            }
            if (response?.success == true) {
                setLoader(false)
                setRecentApplicationData(response?.data?.applications)
                setAllApplicationData(response?.data?.applications)
            } else {
                setLoader(false)
                setRecentApplicationData([])
                setAllApplicationData([])
            }
        } catch (e) {
            setLoader(false)
            throw e
        }
    }



    return (
        <div className='student_app_main_container'>
            <div>
                {/* <MultiSelectFilter /> */}
                <Filters filterConfigs={filterConfigs} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} selectedFiltersIds={selectedFiltersIds} setSelectedFiltersIds={setSelectedFiltersIds} />
            </div>
            <div className='student_application_main'>
                <div className='student_app_labels'>
                    <label>Recent Applications</label>
                </div>
                {loader ?
                    <div className="h-[250px] flex items-center justify-center">
                        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
                    </div>
                    :
                    (recentApplicationData && recentApplicationData.length > 0) ?
                        <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-6 student_application_card_main'>
                            {recentApplicationData.map((item, index) => {
                                return (
                                    <StudentApplicationCard key={index} item={item} permission={permission} userRole={userRole}/>
                                )
                            })}
                        </div>
                        :
                        <div className="text-center h-[350px] content-center">
                            <p className="text-gray-400 text-sl">Recent applications will appear here once available.</p>
                        </div>
                }
                <div className='student_app_labels'>
                    <label>All Applications</label>
                </div>
                {loader ?
                    <div className="h-[250px] flex items-center justify-center">
                        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
                    </div>
                    :
                    allApplicationData && allApplicationData.length > 0 ?
                        <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-6 student_application_card_main'>
                            {allApplicationData.map((item, index) => {
                                return (
                                    <StudentApplicationCard key={index} item={item} permission={permission} userRole={userRole}/>
                                )
                            })}
                        </div> :
                        <div className="text-center h-[350px] content-center">
                            <p className="text-gray-400 text-sl">All applications will appear here once available.</p>
                        </div>
                }

            </div>
        </div>
    )
}
